




















































































































import { faMedal } from '@fortawesome/free-solid-svg-icons'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import QnaService from '~/services/qna/QnaService'
import { UserType } from '~/models/user/types'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CAvatar
  },
  async mounted() {
    this.leaderboardData = await this.$dep(QnaService).fetchLeaderboard()
    this.isLoading = false
  },
  data() {
    return {
      leaderboardData: [],
      isLoading: true
    }
  },

  computed: {
    UserType: () => UserType,
    icons() {
      return {
        medal: faMedal
      }
    },
    fistLeaderboardItem() {
      return this.leaderboardData[0]
    }
  },
  methods: {}
})
